<div class="flex flex-col bg-card overflow-hidden">
  <form>
    <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 pt-2 pb-2 border-b flex items-center">
      <div class="flex items-center flex-auto" *ngIf="editMode">
        <app-form-field [fieldDef]="titleFieldDef" [model]="unit" (onUpdate)="update($event)"></app-form-field>
      </div>
      <div class="flex flex-col">
        <div *ngIf="!editMode" class="font-bold text-md text-secondary uppercase tracking-wider">
          {{ panelDef.title }}
        </div>
      </div>
      <div class="ml-auto" *ngIf="canEditPanelDef">
        <button mat-icon-button type="button" *ngIf="!editMode" [matMenuTriggerFor]="listCard09Menu">
          <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
        </button>
        <mat-menu #listCard09Menu="matMenu">
          <button mat-menu-item (click)="toggleEditMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Edit Layout
          </button>
        </mat-menu>
        <button
          class="cancel-button"
          mat-icon-button
          type="button"
          *ngIf="editMode"
          [matTooltip]="'Cancel'"
          (click)="cancelEdits()"
        >
          <mat-icon [svgIcon]="'cancel'"></mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          *ngIf="editMode && (!fields || fields.length <= 0)"
          [matTooltip]="'Add Row'"
          #addContactPanelOrigin
          (click)="addRow(0)"
        >
          <mat-icon [svgIcon]="'add_circle'"></mat-icon>
        </button>

        <!-- Save button -->
        <button mat-icon-button *ngIf="editMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon [svgIcon]="'save'"></mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="this.units.length === 0" class="flex flex-col items-center justify-center h-full py-8">
      <mat-icon class="icon-size-40" [svgIcon]="'toc'"></mat-icon>
      <p class="text-2xl text-secondary font-medium mt-4">No Units Associated</p>
    </div>

    <div class="flex flex-col p-8" *ngIf="this.units.length > 0">
      <div *ngIf="this.units.length > 1">
        <mat-form-field class="subject flex-auto" *ngIf="!editMode">
          <mat-label>Unit</mat-label>
          <mat-select [value]="unit.id" (selectionChange)="onSelectionChange($event)">
            <mat-option *ngFor="let propertyUnit of this.units" [value]="propertyUnit.id">
              {{ propertyUnit.unit_number }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <ng-container *ngIf="editMode">
        <div cdkDropListGroup>
          <div
            class="flex flex-col gt-xs:flex-row items-center edit-field-placeholder"
            *ngFor="let fieldRow of fields; let rowIndex = index; let firstRow = first; let lastRow = last"
            cdkDropList
            [cdkDropListData]="fieldRow"
            (cdkDropListDropped)="dropped($event)"
            cdkDropListOrientation="horizontal"
          >
            <div
              cdkDrag
              *ngFor="let fieldName of fieldRow; let colIndex = index; let firstCol = first; let lastCol = last"
            >
              <div class="edit-field-placeholder-content">
                <ng-container
                  dynamicFormRow
                  [elmType]="'select-field'"
                  [baseClassNames]="'flex flex-col '"
                  (allowAddNewColumn)="allowAddNewColumn($event, rowIndex)"
                >
                  <ng-container *ngIf="lookupField(fieldName) as fieldDef">
                    <mat-icon
                      class="drag-handler"
                      svgIcon="drag_indicator"
                      matTooltip="Drag me"
                      cdkDragHandle
                    ></mat-icon>
                    <select-field
                      [data]="dataOrig"
                      class="flex flex-col select-field"
                      [fieldDef]="fieldDef"
                      (update)="onFieldSelectionChange($event, rowIndex, colIndex)"
                      [model]="panelDef"
                      [rowIndex]="rowIndex"
                      [colIndex]="colIndex"
                    >
                    </select-field>
                  </ng-container>
                  <button
                    class="remove-email-field"
                    type="button"
                    *ngIf="!(firstRow && lastRow)"
                    mat-icon-button
                    (click)="removeField(rowIndex, colIndex)"
                    matTooltip="Remove"
                  >
                    <mat-icon [svgIcon]="'cancel'"></mat-icon>
                  </button>
                  <button
                    class="add-email-field"
                    type="button"
                    *ngIf="lastCol"
                    mat-icon-button
                    [disabled]="rowActionDisabled[rowIndex]"
                    (click)="addField(rowIndex, colIndex)"
                    matTooltip="Add"
                  >
                    <mat-icon [svgIcon]="'add_circle'"></mat-icon>
                  </button>
                  <button
                    class="add-email-field"
                    type="button"
                    *ngIf="lastCol"
                    mat-icon-button
                    (click)="addRow(rowIndex)"
                    matTooltip="Add"
                  >
                    <mat-icon [svgIcon]="'library_add'"></mat-icon>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!editMode">
        <div class="flex flex-col gt-xs:flex-row" *ngFor="let fieldRow of fields">
          <ng-container *ngFor="let fieldName of fieldRow">
            <ng-container *ngIf="lookupField(fieldName) as fieldDef">
              <app-form-field
                [fieldDef]="fieldDef"
                [model]="unit"
                (onUpdate)="update($event)"
                [data]="data"
                [readonly]="readonly || fieldDef?.meta?.readonly || fieldDef?.locked"
              ></app-form-field>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </form>
</div>
